import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './ClientEdit.module.css' 
import Mobile from "../../../../assets/Icon/Mobile";
import At from "../../../../assets/Icon/At";
import Id from "../../../../assets/Icon/Id";
import User from "../../../../assets/Icon/User";
import Edit from "../../../../assets/Icon/Edit";

const ClientEditModal = ({ clientService, defaultClient }) => {
    const clientResetData = {
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        password: "",
        mobile: ""
    }

    const initEditClient = (client) => {
        return {
            id: client.id,
            firstname: client.firstname,
            lastname: client.lastname,
            personal: client.personal, 
            email: client.email, 
            mobile: client.mobile, 
        }
    }

    const [newClient, setNewClient] = useState(clientResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validateClient = (client) => {
        const messages = {};
    

        if (client.firstname.length < 2) {
            messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
        }

        if (client.lastname.length < 2) {
            messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
        }

        if (client.personal.length != 11) {
            messages.personal = { message: 'საჭროა 11 სიმბოლო', isValid: false };
        }

        if (client.mobile.length != 9) {
            messages.mobile = { message: 'საჭროა 9 სიმბოლო', isValid: false };
        }

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!client.email || client.email.length === 0 || !emailRegex.test(client.email)) {
            messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
        }
  
  
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateClient(newClient)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateClient(newClient)
        }
      }, [newClient, isFirstValidated]);

      useEffect(() => {
        const editedCar = initEditClient(defaultClient)
         setNewClient(editedCar)
    }, [defaultClient]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateClient(newClient)

        if (isValidate === true) {
            clientService.update(newClient)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true) 
        } 
         
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewClient(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false) 
    }
  
    return (
        <div>
            <span className={ cl.editBtn } onClick={() => openAdd()} >
                <Edit/> განახლება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Edit /></span> განახლება</h3>
                </div>
  
                <div className={cl.inp2col}>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.firstname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="სახელი" name="firstname" value={newClient.firstname} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.lastname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="გვარი" name="lastname" value={newClient.lastname} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                </div>

                <div className={cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS"
                            className={validates && validates.personal ? cl.input + ' ' + cl.errorInput : cl.input}
                            placeholder="პირადი ნომერი" name="personal" value={newClient.personal} onChange={handleClientChange} autoComplete="off" />
                        <div className={cl.crmIcon}>
                            <Id />
                        </div>
                    </div>
                    {validates && validates.personal &&
                        <div className={cl.errorMsg} >{validates.personal.message}</div>}
                </div>


                <div className={cl.inp2col} style={{ marginBottom: 0 }}>
                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.mobile ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="მობილური" name="mobile" value={newClient.mobile} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}><Mobile /></div>
                        </div>
                        {validates && validates.mobile &&
                            <div className={cl.errorMsg} >{validates.mobile.message}</div>}

                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.email ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="ელ-ფოსტა" name="email" value={newClient.email} onChange={handleClientChange} autoComplete="off" />
                            <div className={cl.crmIcon}><At /></div>
                        </div>
                        {validates && validates.email &&
                            <div className={cl.errorMsg} >{validates.email.message}</div>}

                    </div>

                </div>


            

                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span> 
            </Modal>
        </div>
    );
};

export default ClientEditModal;